<template>
  <aha-context-menu ref="context-menu-actions">
    <h5 class="break-words context-menu-header">
      {{ presentation.name }}
    </h5>
    <ul>
      <li
        class="context-menu-item"
        :class="{disabled: isDisableEditPresentation}"
        @click="handleSlideUpMenuClick('private', $event)"
        v-if="!isGuestUser"
      >
        <aha-icon
          class="text-base-70"
          v-if="presentation.privateMode"
          name="lockv2"
          viewBox="0 0 14 20"
          width="20"
          height="20"
          v-tooltip="$i18nPresenter.t('Private: Audience cannot see or interact with your slides')"
        />

        <aha-icon
          class="text-base-70"
          v-else
          name="icon-multiple-language"
          viewBox="0 0 20 20"
          width="20"
          height="20"
          v-tooltip="$i18nPresenter.t('Public: Audience can see and interact with your slides')"
        />
        <span>{{ presentation.privateMode ? $i18nPresenter.t('Private') : $i18nPresenter.t('Public') }}</span>
      </li>
      <li
        class="context-menu-item"
        :class="{disabled: isDisableEditPresentation}"
        @click="handleSlideUpMenuClick('rename', $event)"
        v-if="!isGuestUser"
      >
        <aha-icon
          class="text-base-70"
          name="edit"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          style="position: relative; left: 1px"
        />
        <span>{{ $i18nPresenter.t('Rename') }}</span>
      </li>
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('share', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="share"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>{{ $i18nPresenter.t('Share') }}</span>
      </li>
      <div class="my-2 border-b border-secondary-20" />
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('export', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="download"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>{{ $i18nPresenter.t('Export') }}</span>
      </li>
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('setting', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="setting"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>{{ $i18nPresenter.t('Setting') }}</span>
      </li>
      <div class="my-2 border-b border-secondary-20" />
      <li
        class="flex context-menu-item border-secondary-20"
        v-if="!isPresenterWhiteLabel"
      >
        <a
          class="flex w-full px-0 context-menu-item"
          href="https://help.ahaslides.com/"
          target="_blank"
          v-tooltip="tooltipHelp"
          @click="clickHelpContext"
        >
          <aha-icon
            class="text-base-70"
            name="question"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          />
          <span
            class="flex-grow text-base-90"
          >
            {{ $i18nPresenter.t('Help Centre') }}
          </span>
          <aha-icon class="text-base-70" name="open-new-window" />
        </a>
      </li>
    </ul>
  </aha-context-menu>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

const iconOpenLink = require('@/assets/images/vector.svg')

export default {
  data: () => ({
    tooltipHelp: {
      content: '',
    },
  }),
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      isGuestUser: (state) => state.currentUser.isGuest,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    this.tooltipHelp.content = this.$i18nPresenter.t('ThisLinkOpensInANewTab', { iconOpenLink })

    EventBus.$on('show-mobile-slide-up-menu', () => {
      if (!this.$refs['context-menu-actions']) return
      this.$refs['context-menu-actions'].show()
    })
  },
  methods: {
    handleSlideUpMenuClick(type, e) {
      if (type === 'private') {
        if (this.isDisableEditPresentation) {
          e.stopPropagation()
          return
        }
        this.$emit('switchPrivateMode')
      }
      if (type === 'rename') {
        if (this.isDisableEditPresentation) {
          e.stopPropagation()
          return
        }
        this._openEditPresentationName()
      }
      if (type === 'setting') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showSetting')
        }, 200)
      }
      if (type === 'export') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showDownload')
        }, 200)
      }
      if (type === 'share') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showShare')
        }, 200)
      }
      if (type === 'shareToEdit') {
        this.$emit('showShareToEdit')
      }
    },

    _openEditPresentationName() {
      if (this.isDisableEditPresentation || this.isBackstage) return
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Editor Header > Presentation Name > Toggle Edit',
      )

      setTimeout(() => {
        EventBus.$emit('open-edit-name')
      }, 1)
    },

    clickHelpContext() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'ContextMenu > Help')
    },
  },
}
</script>
